import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ButtonType } from '@/components/CmgButton/cmg-button';
import { CountryCode } from '@/store/ui';
import { AnalyticsEventCategory, AnalyticsEventAction } from '@/services/google/google-analytics.services';
import { hideChatWindow } from '@/scripts/amelia-pepper-integration';

@Component({
  name: 'CmgAccountModalMenuLinks',
})
export default class CmgAccountModalMenuLinks extends Vue {
  get buyGiftCardsUrl(): string {
    return this.$services.config.getBuyGiftCardsUrl();
  }

  get shouldShowBuyGiftCardsLink(): boolean {
    return this.$appStore.state.ui.countryProfile.countryCode == CountryCode.US;
  }

  get supportUrl(): string {
    return this.$services.config.getSupportUrl();
  }

  onClickSignOut(event: any) {
    // Don't show sign out warning if bag is empty
    const order = this.$services.order.getCurrentOrder();
    if (!order || !order.order.meals || order.order.meals.length == 0) {
      this.signOut();
      this.$services.ui.nextFocus('sign-in');
      return;
    }

    const signOutYesOption = {
      text: 'YES, SIGN OUT',
      type: ButtonType.Primary,
      onClick: () => {
        signOutYesOption.isLoading = true;
        return this.signOut();
      },
      isLoading: false,
    };
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('basicError', true, {
      header: `ARE YOU SURE?`,
      content: 'If you sign out, the contents of your bag will be lost.',
      options: [
        {
          text: 'Cancel',
          type: ButtonType.Secondary,
          onClick: () => this.$services.ui.setModalVisibility('basicError', false),
        },
        signOutYesOption,
      ],
    });
    this.$services.ui.firstFocus();
    this.$services.ui.nextFocus('sign-in');
  }

  signOut(): Promise<void> {
    return this.$services.customer.signOut().then(() => {
      this.$services.googleAnalytics.sendCustomEvent({ 
        category: AnalyticsEventCategory.Customer, 
        action: AnalyticsEventAction.SignOutSuccess
      });
    }).finally(async () => {
      hideChatWindow();
      // Clear out the stored JWT in the common iframe
      const iframe = (document.getElementById('sessionFrame') as unknown) as HTMLIFrameElement;
      if (iframe) {
        const win = iframe.contentWindow;
        if (win) {
          win.postMessage(JSON.stringify({ key: 'cmg-vuex', method: 'remove' }), this.$services.config.getSessionFrameUrl());
        }
      }
      // TODO: investigate why the page is being forcibly reloaded here (shouldn't do this in a SPA)
      window.location.href = '/';
    });
  }

  tabToModalStart() {
    this.$services.ui.focusDiv('.modal-content');
  }
}
